// extracted by mini-css-extract-plugin
export var actionText = "_hu-4";
export var container = "_hu-0";
export var leftSection = "_hu-1";
export var rightSection = "_hu-2";
export var settingsButton = "_hu-6";
export var settingsIcon = "_hu-7";
export var shortcut = "_hu-5";
export var shortcutGroup = "_hu-3";